export interface IndicatorInfo {
  title: string;
  description: string[];
}

export const indicators: Record<string, IndicatorInfo> = {
  'GlobalLiquidityAlpha': {
    title: 'Global Liquidity Alpha Signal',
    description: [
      '**O que é:** Mede a liquidez global (bancos centrais: Fed, BoJ, PBoC, BoE, BCE), ajustada por RRP e TGA; normaliza em um ratio com threshold.',
      '**Como ler:**',
      '• Verde (ratio ≤ threshold): regime de liquidez favorável (suporte a risco).',
      '• Vermelho (ratio > threshold): contração de liquidez (cautela).',
      '• Alerta "entered green zone": cruzamento para baixo do limiar.',
      '**Boas práticas:** use em D/W como contexto macro e combine com outros sinais (preço, derivativos).',
      '**Limitações:** séries podem ter atraso/revisões; thresholds extremos reduzem utilidade.'
    ]
  },
  'SSRAlpha': {
    title: 'SSR Alpha Signal', 
    description: [
      '**O que é:** Compara market cap (ex.: BTC) com base de stablecoins (USDT/USDC/DAI/USDD/BUSD), normaliza e usa Bandas de Bollinger.',
      '**Como ler:**',
      '• Cruzar acima da banda superior: possível excesso/overheat.',
      '• Cruzar abaixo da banda inferior: possível oportunidade/cheap.',
      '**Boas práticas:** bom em D/3D/1W como filtro de assimetria; combine com S/R e fluxo on-chain.',
      '**Limitações:** mudanças metodológicas deslocam níveis; bandas curtas dão falsos positivos, longas atrasam.'
    ]
  },
  'CreditSpreadAlpha': {
    title: 'Credit Spread Alpha Signal',
    description: [
      '**O que é:** HY spread = rendimento de high yield – US10Y; mede stress vs apetite a risco.',
      '**Como ler:**',
      '• Spread alto (≈ +2σ): stress → frequentemente sinal contrarian de compra.',
      '• Spread comprimido (< ~1.5%): risk-on → atenção a exaustão.',
      '**Boas práticas:** indicador macro (semanas/meses); confirme com liquidez global/vol.',
      '**Limitações:** extremos podem persistir; ciclo/inflação deslocam patamares.'
    ]
  },
  'FinancialRiskAlpha': {
    title: 'Financial Risk Alpha (NFCI Δ semanal invertida)',
    description: [
      '**O que é:** Variação semanal do NFCI (invertida) para detectar flips de regime (aperto ↔ relaxamento).',
      '**Como ler:**',
      '• Flip para verde: relaxamento (favorece risco).',
      '• Flip para vermelho: aperto (prudência).',
      '**Boas práticas:** ótimo como sinal de regime em W/D; ajuste tático de posição.',
      '**Limitações:** periodicidade semanal; feriados/revisões atrasam.'
    ]
  }
};

export function getIndicatorInfo(indicatorKey: string): IndicatorInfo {
  return indicators[indicatorKey] || {
    title: 'Indicador Desconhecido',
    description: ['Selecione um indicador válido na URL para ver a descrição.']
  };
}